import { useTranslation } from 'react-i18next'
import { useCallback } from 'react'
import {
  convertBefehl4FormDataToModel,
  convertModelToBefehl4FormData
} from './converters'
import Auftrag4_10Form from './Auftrag4_10Form'
import { useBefehlForm } from '../../../hooks'
import { BefehlFormWrapper, BefehlFormProps } from '../Generic'
import { Befehl4 } from '../../../models'
import { Befehl4FormData, createBefehl4FormValidationSchema } from './schema'

/**
 * Main form component for Befehl 4
 */
export default function Befehl4Form({
  befehl,
  onSubmit,
  readOnly = false,
  'data-testid': testId = 'befehl-4-form',
  activateEmptyFieldWarnings = false,
  displayHeaderOnly = false
}: Readonly<BefehlFormProps<Befehl4>>) {
  const { t } = useTranslation('ui-befehle')

  const formMethods = useBefehlForm<
    ReturnType<typeof createBefehl4FormValidationSchema>
  >({
    readOnly,
    activateEmptyFieldWarnings,
    schema: createBefehl4FormValidationSchema(),
    initialData: befehl ? convertModelToBefehl4FormData(befehl) : undefined
  })

  const handleSubmit = useCallback(
    (data: Befehl4FormData) => {
      const updatedBefehl = convertBefehl4FormDataToModel(
        data,
        befehl.frontendId
      )
      onSubmit(updatedBefehl)
    },
    [befehl.frontendId, onSubmit]
  )

  return (
    <BefehlFormWrapper<Befehl4FormData>
      befehlKennung="4"
      title={t('befehle.4.description')}
      formMethods={formMethods}
      onSubmit={handleSubmit}
      readOnly={readOnly}
      data-testid={`${testId}-wrapper`}
      activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      displayHeaderOnly={displayHeaderOnly}
    >
      {/* Auftrag 4.10 */}
      <Auftrag4_10Form
        readOnly={readOnly}
        data-testid={`${testId}-auftrag-4-10`}
        activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      />
    </BefehlFormWrapper>
  )
}
